// extracted by mini-css-extract-plugin
module.exports = {"machineParameterBoxWrapper":"styles_machineParameterBoxWrapper__86X2j","machineParameterBoxList":"styles_machineParameterBoxList__2IJez"};